<div class="col-12 mb-4">
    <table class="table table-bordered">
        <thead>
            <tr>
                <th class="table-header">Type</th>
                <th class="table-header">Name</th>
                <th class="table-header">Attachment Type</th>
                <th class="table-header">Uploaded Date</th>
            </tr>
        </thead>

        <tbody>
            @if(attachments && attachments.length > 0){
            @for(attachment of attachments; track $index){
            <tr>
                <td class="w-5 text-center">
                    <button (click)="showAttachment(attachment)" title="{{attachment.attachmentName}}" class="btn">
                        @if (attachment.contentType === 'application/pdf') {
                        <img alt="attachment {{attachment.blobStorageFilename}}"
                            src="https://icons.iconarchive.com/icons/graphicloads/filetype/64/pdf-icon.png" width="50"
                            height="50" />
                        }@else if(attachment.contentType === 'image/png') {
                        <img alt="attachment {{attachment.blobStorageFilename}}"
                            src="https://icons.iconarchive.com/icons/graphicloads/filetype/64/png-icon.png" width="50"
                            height="50" />
                        }@else if(attachment.contentType === 'image/jpg' || attachment.contentType==='image/jpeg'){
                        <img alt="attachment {{attachment.blobStorageFilename}}"
                            src="https://icons.iconarchive.com/icons/graphicloads/filetype/64/jpg-icon.png" width="50"
                            height="50" />
                        }
                    </button>
                </td>
                <td>{{ attachment.attachmentName }}</td>
                <td>{{attachment?.attachmentTypeCode}}</td>
                <td>{{ attachment?.uploadedOn | date: 'dd/MM/yyyy h:mm a'}}</td>
            </tr>
            }
            }@else{
            <tr>
                <td colspan="6">No attachments</td>
            </tr>
            }
        </tbody>
    </table>
</div>